<template>
    <b-form-group label-for="occupationGroups">
        <template slot="label">
            <slot name="label">
                <span v-if="showLabel">
                    {{ $t('form.label.occupationGroups') }}
                </span>
            </slot>
        </template>
        <multiselect
            id="occupationGroups"
            :state="state"
            :selected="value"
            :options="options"
            :loading="isLoading"
            :disabled="disabled"
            :placeholder="placeholder"
            :groupLabel="groupLabelKey"
            :groupValues="groupValuesKey"
            :groupSelect="enableSelectAll"
            :closeOnSelect="closeOnSelect"
            @changeValue="onChangeValue"
            @click="getOccupationGroups()"
        />
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import api from '@/services/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'

export default {
    name: 'OccupationGroups',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
        state: {
            type: Boolean,
            default: null,
        },
        disabled: Boolean,
        placeholder: String,
        enableSelectAll: Boolean,
        loadDataWhenMounted: Boolean,
    },
    data() {
        return {
            isLoading: false,
            isLoaded: false,
            occupationGroups: [],
        }
    },
    computed: {
        groupValuesKey() {
            return this.enableSelectAll ? 'items' : null
        },
        groupLabelKey() {
            return this.enableSelectAll ? 'group' : null
        },
        options() {
            const items = mapperToOptions(
                this.occupationGroups,
                undefined,
                'name'
            )

            if (this.enableSelectAll) {
                return [{ items, group: i18n.t('form.button.allOptions') }]
            }

            return items
        },
    },
    mounted() {
        if (this.loadDataWhenMounted) {
            this.getOccupationGroups()
        }
        this.$emit('ready', true)
    },
    methods: {
        onChangeValue(event) {
            this.$emit('update:value', event)
            this.$emit('change')
        },
        getOccupationGroups() {
            if (this.isLoaded) {
                return
            }

            this.isLoading = true
            api.get('/sections', {
                params: {
                    ascending: 1,
                    orderBy: 'name',
                    searchFields: 'type:in',
                    search: 'type:occupation_group',
                },
            })
                .then(resp => {
                    this.occupationGroups = resp.data.data
                })
                .catch(console.log)
                .finally(() => {
                    this.isLoaded = true
                    this.isLoading = false
                    this.$emit('loaded', true)
                    this.$emit('options-loaded', this.options)
                })
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';

.c-th:hover {
    cursor: pointer;
}
</style>
